var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.3 13C6.57614 13 6.8 12.7761 6.8 12.5V9.97059C6.8 9.69445 7.02386 9.47059 7.3 9.47059H8.7C8.97614 9.47059 9.2 9.69445 9.2 9.97059V12.5C9.2 12.7761 9.42386 13 9.7 13H10.8429C11.119 13 11.3429 12.7761 11.3429 12.5V8.79412C11.3429 8.51798 11.5667 8.29412 11.8429 8.29412H12.6776C13.1383 8.29412 13.3538 7.72398 13.0084 7.4192L8.33081 3.29189C8.1418 3.12512 7.8582 3.12512 7.66919 3.29189L2.99158 7.4192C2.64615 7.72398 2.86173 8.29412 3.32239 8.29412H4.15714C4.43329 8.29412 4.65714 8.51798 4.65714 8.79412V12.5C4.65714 12.7761 4.881 13 5.15714 13H6.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.d69c865311b4b732731411a79eed8f01.svg";
export { ForwardRef as ReactComponent };